













































import { Component, Vue } from 'vue-property-decorator';
import { ActionNames } from '@/constants/ActionNames';
import Loading from '@/components/Loading.vue';

@Component({
  components: {
    Loading,
  },
})
export default class Login extends Vue {
  public email: string = '';

  public password: string = '';

  public loading: boolean = false;

  public error: boolean = false;

  public async doLogin() {
    this.loading = true;

    const success = await this.$store.dispatch(ActionNames.LOGIN, {
      email: this.email,
      password: this.password,
    });

    this.error = !success;
    this.loading = false;
  }
}
